import { render, staticRenderFns } from "./userGroupManagement.vue?vue&type=template&id=5c580c84&scoped=true&"
import script from "./userGroupManagement.vue?vue&type=script&lang=js&"
export * from "./userGroupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c580c84",
  null
  
)

export default component.exports